var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.988,
    height: 14,
    viewBox: "0 0 13.988 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f25f84;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.725 53.286)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.725 -53.286)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.167,7.262a1.881,1.881,0,0,0-2.652,0h0l-3.786,3.8-3.807-3.8A1.875,1.875,0,0,0,7.27,9.912h0l3.807,3.809L7.27,17.507a1.882,1.882,0,0,0,0,2.65,1.9,1.9,0,0,0,1.326.558,1.865,1.865,0,0,0,1.326-.558h0l3.807-3.784,3.807,3.784a1.76,1.76,0,0,0,1.3.558,1.873,1.873,0,0,0,1.326-3.187h0L16.36,13.721l3.807-3.809A1.882,1.882,0,0,0,20.167,7.262Z",
    transform: "translate(-6.725 -6.715)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.98388278f68027550865d78f8878c91a.svg";
export { ForwardRef as ReactComponent };